import { WIDGET_ORIGIN } from "@/embed/widgetOrigin";

/** Absolute (cross-origin-safe) URL for a same-origin Manly asset under /manly/.
 * Uses the captured widget origin so a card embedded on another domain still
 * loads images from the widget host, not the embedding page. Empty origin
 * (hosted page / tests) -> root-relative. Mirrors AURAL's assetUrl. */
export function assetUrl(file: string): string {
  const base = WIDGET_ORIGIN.replace(/\/+$/, "");
  return `${base}/manly/${file}`;
}

/** The one product hero: the Citrus Breeze Natural Body Wash beside its
 *  reported results (94 / 91 / 89). Manly's own PDP asset (bw_v1_img1),
 *  re-encoded to webp at 900px. Square, so it fills .qk-manly-hero's 1/1 box.
 *
 *  The funnel sells the body wash alone, so this deliberately replaces the old
 *  deodorant-plus-wash pair shot: never show a parent a product we don't sell. */
export const PRODUCT_IMAGE = "manly-results.webp";
